export const ids = [
	'embedded-job-header', // Carters embedded job header format, very specific to their needs.
] as const;
